export default __webpack_public_path__ + "static/promo-interest-free-8593d686675d8b960e653cddc3a241c4.jpg";